import React from 'react';
import { ComponentProps } from './ComponentProps';
import { useBiClickLogger } from '../hooks/useBiClickLogger';

const BiOption: React.FC<Partial<ComponentProps>> = ({
  biData,
  innerRef,
  stopPropagation,
  ...props
}) => {
  // _value is used in useBiClickLogger to compare with
  //  the parent select's value and recognize a change
  // so add it automatically if it's not there
  if (biData && props.value) {
    biData._value = biData._value || props.value.toString();
  }
  const { setTrackingRef } = useBiClickLogger(biData, stopPropagation);
  return (
    <option
      {...props}
      ref={node => {
        setTrackingRef(node);
        innerRef && innerRef(node);
      }}
    />
  );
};
BiOption.displayName = 'BiOption';

export default BiOption;
